type Props = { anchorID: string };

export function Anchor({ anchorID }: Props) {
  return <div id={anchorID} />;
}
